<p-toast></p-toast>
<p-card>
    <div style="text-align: center;">
        <p-progressSpinner *ngIf="loading" [style]="{width: '200px', height: '200px'}"></p-progressSpinner>
    </div>
    <div class="card" *ngIf="!loading">
        <div class="p-grid p-fluid">
            <div class="p-col-12 p-md-12 p-lg-12">
                <label for="empresa" style="font-family: system-ui;">Empresa</label>
                <p-dropdown class="p-inputtext-sm" [options]="empresas" [(ngModel)]="selecionarEmpresa"
                    [showClear]="true" optionLabel="nome_fantasia" placeholder="Selecione a Empresa"></p-dropdown>
            </div>
        </div>
        <div class="p-grid p-fluid">
            <div class="p-col-12 p-md-12 p-lg-12">
                <label for="selecionarOrigem" style="font-family: system-ui;">Setor</label>
                <p-dropdown class="p-inputtext-sm" [options]="origens" [(ngModel)]="selecionarOrigem" [showClear]="true"
                    optionLabel="nome" placeholder="Selecione o Setor"></p-dropdown>
            </div>
        </div>
        <div class="p-grid p-fluid">
            <div class="p-col-12 p-md-6 p-lg-4">
                <label for="selecionarPeriodo" style="font-family: system-ui;">Período</label>
                <p-dropdown class="p-inputtext-sm" [options]="periodos" [(ngModel)]="selecionarPeriodo"
                    optionLabel="nome" optionValue="nome" (onChange)="onChangePeriodo($event)"></p-dropdown>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3">
                <label style="font-family: system-ui;">Data Inicial</label>
                <p-calendar class="p-inputtext-sm" [(ngModel)]="data_inicial" dateFormat="dd/mm/yy" [showIcon]="true"
                    inputId="icon" showButtonBar="true">
                </p-calendar>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3">
                <label style="font-family: system-ui;">Data Final</label>
                <p-calendar class="p-inputtext-sm" [(ngModel)]="data_final" dateFormat="dd/mm/yy" [showIcon]="true"
                    inputId="icon" showButtonBar="true">
                </p-calendar>
            </div>
            <div class="p-col-12 p-md-6 p-lg-2" style="align-self: flex-end;">
                <button style="height: 39.272px; background-color: rgb(167, 32, 8);" pButton pRipple type="button" label="Pesquisar"
                    class="p-button-raised" (click)="pesquisar()"></button>
            </div>
        </div>
        <div class="p-grid nested-grid">
            <div class="p-col-12 p-md-6 p-lg-8">
                <p-table #dt [value]="lista" selectionMode="single"
                    styleClass="p-datatable-sm p-datatable-striped" dataKey="descricaoTitulo" [scrollable]="true"
                    scrollHeight="300px" (onRowSelect)="onRowSelect($event)">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Origem</th>
                            <th style="text-align: center;font-size: 15px;">Total Carteira</th>
                            <th style="text-align: center;font-size: 15px;">Total Clientes</th>
                            <th style="text-align: right;font-size: 15px;">Qtd. Elev.</th>
                            <!-- <th style="text-align: right;font-size: 15px;">Qtd. Escada</th>
                            <th style="text-align: right;font-size: 15px;">Qtd. Plat.</th> -->
                            <th style="text-align: right;font-size: 15px;">Total Equip.</th>
                            <th style="text-align: right;font-size: 15px;">Média Equip.</th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-cliente>
                        <tr [pSelectableRow]="cliente">                        
                            <td><b>{{cliente.descricaoTitulo}}</b></td>
                            <td style="text-align:right;font-size: 15px;">{{cliente.valor_contrato_texto}}</td>
                            <td style="text-align:right;font-size: 15px;">{{cliente.cod_cliente}}</td>
                            <td style="text-align:right;font-size: 15px;">{{cliente.qtd}}</td>
                            <!-- <td style="text-align:right;font-size: 15px;">{{cliente.qtd_escada}}</td>
                            <td style="text-align:right;font-size: 15px;">{{cliente.qtd_plataforma}}</td> -->
                            <td style="text-align:right;font-size: 15px;">{{cliente.qtd_total}}</td>
                            <td style="text-align:right;font-size: 15px;">{{cliente.media_elevador_texto}}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <div class="p-col-12 p-md-6 p-lg-4">
                <p-chart type="pie" [data]="grafico"></p-chart>
            </div>
        </div>
    </div>
</p-card>
<!-- A - Total da Carteira -->
<p-dialog header="Total da Carteira" [(visible)]="displayTotalCarteira" [modal]="true" [style]="{width: '90vw'}"
    [baseZIndex]="10000">

    <p-table #dt [value]="listaTotalCarteira" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem"  scrollDirection="both" responsiveLayout="scroll" scrollHeight="400px">
        <ng-template pTemplate="header">
            <tr>
                <th style="text-align:left;width: 400px;font-size:12px;">Nome</th>
                <th style="text-align:left; width: 100px;font-size:12px;">Contrato</th>
                <th style="text-align:left;width: 300px;font-size:12px;">Endereço</th>
                <th style="text-align:left;width: 200px;font-size:12px;">Bairro</th>
                <th style="text-align:left;width: 200px;font-size:12px;">Cidade</th> 
                <th style="text-align:left; width: 100px;font-size:12px;">Estado</th>
                <th style="text-align:left; width: 100px;font-size:12px;">Valor</th>
                <th style="text-align:left; width: 100px;font-size:12px;">Elevs.</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">

                <td style="text-align:left;width: 400px;font-size:12px;">{{cliente.nome}}
                </td>
                <td style="text-align:left;width: 100px;font-size:12px;">{{cliente.contrato }}</td>
                <td style="text-align:left;width: 300px;font-size:12px;">{{cliente.end_rps}}</td>
                <td style="text-align:left;width: 200px;font-size:12px;">{{cliente.bairro}}</td>
                <td style="text-align:left;width: 200px;font-size:12px;">{{cliente.cidade}}
                </td>
                <td style="text-align:left;width: 100px;font-size:12px;">{{cliente.estado }}</td>
                <td style="text-align:left;width: 100px;font-size:12px;">{{cliente.valor_contrato | currency:'BRL':true}}</td>
                <td style="text-align:left;width: 100px;font-size:12px;">{{cliente.qtd }}</td>
            </tr>
        </ng-template>
    </p-table>
    <div>

    </div>
    <ng-template pTemplate="footer">
        <div class="p-col-12 p-md-6 p-lg-2">
            <span style="
            background-color: cornflowerblue;
            padding: 4px;
            border-radius: 10px;
            float: left;">
                <b>TOTAL NOMES: {{totalTotalCarteira}}</b></span>
        </div>
        <!-- <div class="p-col-12 p-md-6 p-lg-6">
            <span style="
            background-color: cornflowerblue;
            padding: 4px;
            border-radius: 10px;
            align-self: center;">
                <b>TOTAL VALOR: {{total_Total_Valor | currency:'BRL':true}}</b></span>
        </div> -->
        <div class="p-col-12 p-md-6 p-lg-12">
            <span style="
            background-color: cornflowerblue;
            padding: 4px;
            border-radius: 10px;
            align-self:left">
                <b>TOTAL ELEVS: {{total_Total_Elev}}</b></span>
        </div>
        <br>
        <div class="p-col-12 p-md-6 p-lg-4" style="float: right;">
            <p-button icon="pi pi-check" (click)="displayTotalCarteira=false" label="FECHAR" styleClass="p-button-text">
            </p-button>
        </div>

    </ng-template>
</p-dialog>
<!-- FIM A - Total da Carteira -->

<!-- B - Novos Clientes -->
<p-dialog header="Novos Clientes" [(visible)]="displayNovosClientes" [modal]="true" [style]="{width: '90vw'}"
    [baseZIndex]="10000">

    <p-table #dt [value]="listaNovosClientes" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem" scrollDirection="both" responsiveLayout="scroll" scrollHeight="400px" >
        <ng-template pTemplate="header">
            <tr>
                <th style="text-align:left;width: 400px;font-size:12px;">Nome</th>
                <th style="text-align:left; width: 100px;font-size:12px;">Contrato</th>
                <th style="text-align:left;width: 300px;font-size:12px;">Endereço</th>
                <th style="text-align:left;width: 300px;font-size:12px;">Bairro</th>
                <th style="text-align:left;width: 200px;font-size:12px;">Cidade</th> 
                <th style="text-align:left; width: 100px;font-size:12px;">Estado</th>
                <th style="text-align:left; width: 100px;font-size:12px;">Valor</th>
                <th style="text-align:left; width: 100px;font-size:12px;">Elevs.</th>

            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">
                
                <td style="text-align:left;width: 400px;font-size:12px;">{{cliente.nome}}
                </td>
                <td style="text-align:left;width: 100px;font-size:12px;">{{cliente.contrato }}</td>
                <td style="text-align:left;width: 300px;font-size:12px;">{{cliente.end_rps}}</td>
                <td style="text-align:left;width: 300px;font-size:12px;">{{cliente.bairro}}</td>
                <td style="text-align:left;width: 200px;font-size:12px;">{{cliente.cidade}}
                </td>
                <td style="text-align:left;width: 100px;font-size:12px;">{{cliente.estado }}</td>
                <td style="text-align:left;width: 100px;font-size:12px;">{{cliente.valor_contrato | currency:'BRL':true}}</td>
                <td style="text-align:left;width: 100px;font-size:12px;">{{cliente.qtd }}</td>

            </tr>
        </ng-template>
    </p-table>
    <div>

    </div>
    <ng-template pTemplate="footer">
        <div class="p-col-12 p-md-6 p-lg-2">
            <span style="
            background-color: cornflowerblue;
            padding: 4px;
            border-radius: 10px;
            float: left;">
                <b>TOTAL NOMES: {{totalNovosClientes}}</b></span>
        </div>
        <!-- <div class="p-col-12 p-md-6 p-lg-6">
            <span style="
            background-color: cornflowerblue;
            padding: 4px;
            border-radius: 10px;
            align-self: center;">
                <b>TOTAL VALOR: {{total_Total_Valor | currency:'BRL':true}}</b></span>
        </div> -->
        <div class="p-col-12 p-md-6 p-lg-12">
            <span style="
            background-color: cornflowerblue;
            padding: 4px;
            border-radius: 10px;
            align-self:left">
                <b>TOTAL ELEVS: {{total_Total_Elev}}</b></span>
        </div>
        <br>
        <div class="p-col-12 p-md-6 p-lg-4" style="float: right;">
            <p-button icon="pi pi-check" (click)="displayNovosClientes=false" label="FECHAR" styleClass="p-button-text">
            </p-button>
        </div>
    </ng-template>
</p-dialog>
<!-- FIM B - Novos Clientes -->

<!-- C - Clientes Cancelados -->
<p-dialog header="Clientes Cancelados" [(visible)]="displayClientesCancelados" [modal]="true" [style]="{width: '90vw'}"
    [baseZIndex]="10000">

    <p-table #dt [value]="listaClientesCancelados" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem" [scrollable]="true" scrollDirection="both" responsiveLayout="scroll" scrollHeight="400px">
        <ng-template pTemplate="header">
            <tr>
                <th style="text-align:left;width: 400px;font-size:12px;">Nome</th>
                <th style="text-align:left; width: 100px;font-size:12px;">Contrato</th>
                <th style="text-align:left;width: 300px;font-size:12px;">Endereço</th>
                <th style="text-align:left;width: 300px;font-size:12px;">Bairro</th>
                <th style="text-align:left;width: 200px;font-size:12px;">Cidade</th> 
                <th style="text-align:left; width: 100px;font-size:12px;">Estado</th>
                <th style="text-align:left; width: 100px;font-size:12px;">Valor</th>
                <th style="text-align:left; width: 100px;font-size:12px;">Elevs.</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">
                <td style="text-align:left;width: 400px;font-size:12px;">{{cliente.nome}}
                </td>
                <td style="text-align:left;width: 100px;font-size:12px;">{{cliente.contrato }}</td>
                <td style="text-align:left;width: 300px;font-size:12px;">{{cliente.end_rps}}</td>
                <td style="text-align:left;width: 300px;font-size:12px;">{{cliente.bairro}}</td>
                <td style="text-align:left;width: 200px;font-size:12px;">{{cliente.cidade}}
                </td>
                <td style="text-align:left;width: 100px;font-size:12px;">{{cliente.estado }}</td>
                <td style="text-align:left;width: 100px;font-size:12px;">{{cliente.valor_contrato | currency:'BRL':true}}</td>
                <td style="text-align:left;width: 100px;font-size:12px;">{{cliente.qtd }}</td>
            </tr>
        </ng-template>
    </p-table>
    <div>

    </div>
    <ng-template pTemplate="footer">
        <div class="p-col-12 p-md-6 p-lg-2">
            <span style="
            background-color: cornflowerblue;
            padding: 4px;
            border-radius: 10px;
            float: left;">
                <b>TOTAL NOMES: {{totalClientesCancelados}}</b></span>
        </div>
        <div class="p-col-12 p-md-6 p-lg-12">
            <span style="
            background-color: cornflowerblue;
            padding: 4px;
            border-radius: 10px;
            align-self:left">
                <b>TOTAL ELEVS: {{total_Total_Elev}}</b></span>
        </div>
        <br>
        <div class="p-col-12 p-md-6 p-lg-4" style="float: right;">
            <p-button icon="pi pi-check" (click)="displayClientesCancelados=false" label="FECHAR" styleClass="p-button-text">
            </p-button>
        </div>

    </ng-template>
</p-dialog>
<!-- FIM C - Clientes Cancelados -->
